package com.findyourbuddies.website

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import org.w3c.dom.HTMLStyleElement

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("html, body") { Modifier.fillMaxHeight() }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {

    LaunchedEffect(Unit) {
        try {
            val styleElement = document.createElement("style") as HTMLStyleElement
            styleElement.innerHTML = """
                @font-face {
                    font-family: 'Waxe';
                    src: url('/fonts/waxe.woff2') format('woff2'),
                         url('/fonts/waxe.woff') format('woff'),
                         url('/fonts/waxe.ttf') format('truetype');
                    font-weight: normal;
                    font-style: normal;
                    font-display: swap;
                }
                
                @font-face {
                    font-family: 'Comfortaa';
                    src: url('/fonts/Comfortaa-Regular.woff2') format('woff2'),
                         url('/fonts/Comfortaa-Regular.ttf') format('truetype');
                    font-weight: normal;
                    font-style: normal;
                    font-display: swap;
                }
                
                .waxe-font {
                    font-family: 'Waxe', 'Arial Black', 'Helvetica Neue', sans-serif !important;
                }
                
                .comfortaa-font {
                    font-family: 'Comfortaa', 'Arial', sans-serif !important;
                }
            """.trimIndent()

            document.head?.appendChild(styleElement)

        } catch (e: Exception) {
            console.error("❌ Erreur lors du chargement des polices:", e.message)
        }
    }

    SilkApp {
        Surface(SmoothColorStyle.toModifier().fillMaxHeight()) {
            content()
        }
    }
}
